/**
 * Функция, которая не делает ничего
 */
export var noop = function () { return undefined; };
